<style lang="scss" scoped>
.page {
    margin-top: 80px;
    padding-top: 30px;
    min-height: calc(100vh - 80px - 81px - 45px);
}
</style>

<template>

    <div>

        <!-- Application navbar -->
        <!-- Contains basic application navitaion such as -->
        <!-- Dashboard, Search, shippings, fleet, notifications, chat, profile -->
        <navbar class="px-45"></navbar>

        <!-- Application content -->
        <div class="container-fluid page px-45">
            <router-view />
        </div>

        <div v-if="!$route.meta.hideFooter">
            <div class="footer d-flex w-100 p-30 mt-45 border-top">
                <div class="mr-auto d-flex">
                    <i-logo class="logo i-20 my-auto"></i-logo> <span class="fs-12 ml-30 my-auto">© Copyright {{ $moment().year() }} Vengo. <a href="https://salamander.be" target="_blank">Salamander</a> takes care of this.</span>
                </div>
                <div></div>
                <div class="ml-auto d-flex">
                    <a :href="$t('bin.toslink')" target="_blank" class="fs-12 ml-30">{{ $t('bin.tos') }}</a>
                    <a :href="$t('bin.insurancelink')" target="_blank" class="fs-12 ml-30">{{ $t('bin.insurance') }}</a>
                    <a @click.stop href="mailto:info@vengo.technology" class="fs-12 ml-30">Contact</a>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import Navbar from "@/components/global/navbar";
import { mapGetters } from "vuex";

export default {
    components: { Navbar },

    computed: {
        ...mapGetters(["language"])
    },
               
    watch: {        
        language: function(newLng, oldLng) {        
            this.$moment.locale(newLng)
            this.$i18n.locale = newLng
        },
    }
};
</script>
